import React from 'react';

import CommentIcon from '@material-ui/icons/Comment';
import { getGradientStyle } from './colors';
import getFullness from './bookingStatHelper';

function ZippityEvent(props) {
  const sum = (list) => list.reduce((a, b) => a + b, 0);
  const { event } = props;
  const {
    serviceVehicle,
    serviceVehicleId,
    scheduleInstance,
    fullnessFilter,
    calendarNotes,
    onClickCalendarNotes,
    scheduleTypeNameToEmoji,
  } = event;

  const CalendarNotesChip = (
    <div className="zippityEventWrapper">
      <button
        className="miniChip calendarNotesIcon"
        type="button"
        onClick={() => {
          onClickCalendarNotes(event);
        }}
      >
        <CommentIcon fontSize="small" /> {calendarNotes.length}
      </button>
    </div>
  );

  if (fullnessFilter === 'dummyAlign') {
    return CalendarNotesChip;
  }

  const AT_HOME_SERVICE_CL_IDS = [108, 109, 110, 111, 112, 113, 114, 116, 117];

  const workClientLocations = scheduleInstance.client_locations.filter(
    ({ id }) => !AT_HOME_SERVICE_CL_IDS.includes(id),
  );

  let clientLocationNames = workClientLocations.map(
    (clientLocation) => clientLocation.short_name,
  );
  if (clientLocationNames.length >= 4) {
    clientLocationNames = clientLocationNames.slice(0, 3);
    clientLocationNames.push('...');
  }

  const serviceTypes = scheduleInstance.offered_service_types;

  const potentialCustomers = scheduleInstance.client_locations.map(
    (clientLocation) => clientLocation.number_potential_customers,
  );
  const totalPotentialCustomers = sum(potentialCustomers);
  const showPotentialCustomers =
    clientLocationNames.length > 0 && totalPotentialCustomers > 0;

  const totalNumBookings = scheduleInstance.current_scheduled_works || 0;
  const totalBookedHours = scheduleInstance.current_total_hours || 0;
  const totalServiceHours = scheduleInstance.current_service_hours || 0;
  const maxHours = scheduleInstance.limit_total_hours || 0;

  const fullness = getFullness(scheduleInstance, fullnessFilter);

  const tooltip = `${totalNumBookings} appointments\nService Time: ${totalServiceHours} hours\nWorkTime: ${totalBookedHours} hours\nWorkTime limit: ${maxHours} hours\n\n${fullness}% full (${totalBookedHours} / ${maxHours})`;

  return (
    <div className="zippityEventWrapper" title={tooltip}>
      {CalendarNotesChip}
      <div className={`zippityEvent serviceVehicleId-${serviceVehicleId}`}>
        <div style={{ flexGrow: 8, minWidth: '120px' }}>
          {clientLocationNames.join(' + ')}
        </div>
        <div style={{ flexShrink: 0 }}>{serviceVehicle.name}</div>
      </div>
      <div className="hideOnMonth">
        {showPotentialCustomers && (
          <div className="bookingStats">
            <div
              className="miniChip"
              style={getGradientStyle(totalPotentialCustomers / 8000)}
            >
              {totalPotentialCustomers} Potential Customers
            </div>
          </div>
        )}
        <hr />
        <div className="bookingStats">
          <div className="bookingStats" style={{ flexGrow: 2 }}>
            <div className="miniChip circle">{totalNumBookings}</div>
            <div
              className="miniChip"
              style={getGradientStyle(totalBookedHours / maxHours || 0)}
            >
              {totalServiceHours} | {totalBookedHours} | {maxHours}
            </div>
            <div className="miniChip" style={getGradientStyle(fullness / 100)}>
              {fullness}%
            </div>
          </div>
          <div className="bookingStats">
            <div className="miniChip">
              {serviceTypes.map((serviceType) => (
                <span
                  key={serviceType}
                  role="img"
                  aria-label={serviceType}
                  title={serviceType}
                >
                  {scheduleTypeNameToEmoji[serviceType]}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ZippityEvent;
